import { Component, Input, ViewChild } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';
import { Select } from 'ionic-angular';


const HTML_TEMPLATE = `
<span class="var-title">{{variable.description}}</span>
<span class="var-optional" *ngIf="variable.optional">({{'COMMON.OPTIONAL' | tTranslate}})</span>
<ion-item>
    <ion-select #select [(ngModel)]="variableValue.value" interface="popover" (ionChange)="onChangeCallback()">
        <ion-option *ngFor="let option of variable.options" [value]="option.variableValue.value">{{option.label}}</ion-option>
    </ion-select>
</ion-item>
`;

const CSS_STYLE = `
variable-select { 
    ion-select {
        width: 100% !important;
        max-width: 100% !important;
    }
}

`;

@Component({
    selector: 'variable-select',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableSelectComponent extends ComponentVariable {

    @Input('variable') variable: Variable;
    @Input('callbackOnChange') callback: Function;
    @ViewChild('select') select: Select;

    variableValue: VariableValue;

    constructor() {
        super();

        this.variableValue = {
            asBoolean: false,
            asString: "",
            value: ""
        }
    }

    ngOnInit() {
        this.setValue(this.variable.defaultValue);
        this.onChangeCallback();
    }

    getValue() {
        return this.variableValue;
    }

    setValue(variableValue: any): void {
        if (variableValue) {
            this.variableValue = {
                asBoolean: (variableValue.value ? true : false),
                asString: String(variableValue.value),
                value: variableValue.value
            }
        }
    }

    getVariable(): Variable {
        return this.variable;
    }

    onChangeCallback(): void {
        this.setValue(this.variableValue);
        this.select.setElementStyle('color', this.getLegendColor());
        this.callback(this);
    }
}
